import React from "react";
import styled from "styled-components";

import brk from "../../util/breakpoints";
import Container from "../Container";

const links = [
  { label: "Home", href: "/#home" },
  { label: "About", href: "/#about" },
  { label: "Work", href: "/#work" },
  { label: "GitHub", href: "https://github.com/JamesTheAlchemist", external: true },
  { label: "LinkedIn", href: "https://www.linkedin.com/in/jamescarlspears/", external: true },
];

const Wrapper = styled.footer`
  width: 100%;
  padding: 46px 0 36px;
  background: var(--bg);
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 42px;
`;

const FooterLinks = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px 32px;
  a {
    color: var(--textMuted);
    font-family: var(--fontBody);
    font-size: 12px;
    text-decoration: none;
    transition: color 0.2s;
    &:hover {
      color: var(--lime);
    }
  }
`;

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: var(--border);
`;

const Legal = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  color: var(--textDim);
  font-family: var(--fontMono);
  font-size: 9px;
  text-transform: uppercase;
  @media ${brk.device.tablet} {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const FooterStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  span {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: var(--lime);
  }
`;

function Footer() {
  return (
    <Wrapper>
      <Container>
        <Content>
          <FooterLinks>
            {links.map((link) => {
              return (
                <a
                  key={link.label}
                  href={link.href}
                  target={link.external ? "_blank" : undefined}
                  rel={link.external ? "noreferrer" : undefined}
                >
                  {link.label}
                </a>
              );
            })}
          </FooterLinks>
          <Divider />
          <Legal>
            <p>{`© ${new Date().getFullYear()} James Spears · Built with React and Three.js`}</p>
            <FooterStatus>
              <span />
              All systems nominal
            </FooterStatus>
          </Legal>
        </Content>
      </Container>
    </Wrapper>
  );
}

export default Footer;
